import { render, staticRenderFns } from "./PerformanceMoreModal.vue?vue&type=template&id=31107cfc"
import script from "./PerformanceMoreModal.vue?vue&type=script&lang=js"
export * from "./PerformanceMoreModal.vue?vue&type=script&lang=js"
import style0 from "./PerformanceMoreModal.vue?vue&type=style&index=0&id=31107cfc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports